import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import ApiService from '../../../services/apiService';
import get from 'lodash/get';
export default {
  name: 'CoreTwoFactorAuthModal',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      inputVerifyToken: '',
      qrImage: null,
      setupStep: 0,
      recoveryCodes: [],
      errorVerify: false,
      errorQrCode: false
    };
  },
  computed: _objectSpread({}, mapState('app', ['color'])),
  watch: {
    isOpen: function isOpen(value) {
      if (value) {
        this.getQRCode();
        this.resetModal();
      }
    }
  },
  methods: {
    get: get,
    resetModal: function resetModal() {
      this.setupStep = 0;
      this.errorQrCode = false;
      this.errorVerify = false;
      this.inputVerifyToken = '';
    },
    getQRCode: function getQRCode() {
      var _this = this;

      var userid = get(this, '$store.state.authentication.user.id') || null;
      ApiService.enableTwoFactorAuth(userid).then(function (res) {
        _this.qrImage = res.qr;
      }).catch(function () {
        _this.errorQrCode = true;
      });
    },
    handleQrCodeScanned: function handleQrCodeScanned() {
      this.setupStep = 1;
    },
    handleCodeChanged: function handleCodeChanged() {
      if (this.errorVerify) {
        this.errorVerify = false;
      }
    },
    handleCodeEntered: function handleCodeEntered() {
      var _this2 = this;

      var userid = get(this, '$store.state.authentication.user.id') || null;
      ApiService.enableTwoFactorAuth(userid, this.inputVerifyToken).then(function (res) {
        if (!res.recoveryCodes) {
          _this2.$emit('close');

          return;
        }

        _this2.setupStep = 2;

        _this2.$emit('enabled');

        _this2.recoveryCodes = res.recoveryCodes;
      }).catch(function () {
        _this2.errorVerify = true;
      });
    }
  }
};